import { render } from "./Finish.vue?vue&type=template&id=6e595962"
import script from "./Finish.vue?vue&type=script&setup=true&lang=js"
export * from "./Finish.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Finish.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e595962"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e595962', __exports__)) {
    api.reload('6e595962', __exports__)
  }
  
  module.hot.accept("./Finish.vue?vue&type=template&id=6e595962", () => {
    api.rerender('6e595962', render)
  })

}


export default __exports__